import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import { useAuthStore, useUserLinkedServicesStore } from '@/stores';

const AXENITA_GUID = '09cfe7f9-cdc0-44d7-9664-cc28b2551392';

interface IMandator {
  id: string;
  name: string;
  rgbHex: string;
}

export const usePmsStore = defineStore("pms", {
  state: () => ({
    mandators: [] as IMandator[],
    error: "" as any,
    laodedMandatorsForServiceId: 0,
    isVerifyingPatient: false,
  }),
  actions: {
    async loadMandators(force = false) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) {
        this.error = "";
        this.mandators = [];
        return;
      }

      const userLinkedServicesStore = useUserLinkedServicesStore();
      const axenitaLinkedService = userLinkedServicesStore.getByLinkedServiceId(AXENITA_GUID);
      if (!axenitaLinkedService) {
        this.error = "";
        this.mandators = [];
        return;
      }

      const loadingServiceId = axenitaLinkedService.id;
      if (!force && this.laodedMandatorsForServiceId === loadingServiceId) return;

      this.error = "";
      this.mandators = [];

      try {
        const response = await api.get<IMandator[]>(`v1.0/pms/mandators?linkedServiceId=${loadingServiceId}`);
        this.mandators = response.data;
        this.laodedMandatorsForServiceId = loadingServiceId;
      } catch (error) {
        this.error = error;
      }
    },
    async verifyPatientNumber(patientNumber: string): Promise<boolean> {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);

      if (!isAuthenticated.value) return false;

      this.error = "";

      const userLinkedServicesStore = useUserLinkedServicesStore();
      const axenitaLinkedService = userLinkedServicesStore.getByLinkedServiceId(AXENITA_GUID);
      if (!axenitaLinkedService) return false;

      this.isVerifyingPatient = true;

      try {
        const response = await api.get<boolean>(`v1.0/pms/.verify/patient-number?linkedServiceId=${axenitaLinkedService.id}&patientNumber=${encodeURIComponent(patientNumber)}`);
        return response.data;
      } catch (error) {
        this.error = error;
        return false;
      } finally {
        this.isVerifyingPatient = false;
      }
    },
    clearMandators() {
      this.error = "";
      this.mandators = [];
      this.laodedMandatorsForServiceId = 0;
    },
    clearError() {
      this.error = "";
    },
  },
  getters: {
    getMandatorById: (state) => (mandatorId: string): IMandator | undefined => {
      return state.mandators.find((m) => m.id === mandatorId);
    },
  },
});
